import React from 'react';
import { useFormikContext } from 'formik';
import { useCreateHousehold, useGetAllOccupantAgeRangesSuspense, useGetAllTenancyTypesSuspense, useGetInspectionHouseholdsSuspense, } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import AddEditContactForm from './AddEditContactForm';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { getNextHouseholdReference } from '../../../../services/contacts';
const ContactFormWrapper = ({ inspectionId, canEdit, variant = 'edit', }) => {
    const { setFieldValue } = useFormikContext();
    const { data: ageRangesResponse } = useGetAllOccupantAgeRangesSuspense(undefined, { query: { staleTime: Infinity, refetchOnMount: false } });
    const { data: tenancyTypesResponse } = useGetAllTenancyTypesSuspense(undefined, { query: { staleTime: Infinity, refetchOnMount: false } });
    const { data: householdsResponse, refetch: refetchHouseholds } = useGetInspectionHouseholdsSuspense(inspectionId, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const addHousehold = useGenericMutationUseCase(useCreateHousehold);
    const ageRanges = unwrapModel(ageRangesResponse);
    const households = unwrapModel(householdsResponse);
    const tenancyTypes = unwrapModel(tenancyTypesResponse);
    if (!ageRanges || !households || !tenancyTypes)
        return null;
    const handleAddHousehold = () => {
        addHousehold.execute({
            data: {
                inspection_id: inspectionId,
                reference: getNextHouseholdReference(households),
            },
        }, undefined, {
            onSuccess: async (response) => {
                await refetchHouseholds();
                const household = unwrapModel(response);
                if (!household)
                    return;
                setFieldValue('occupant.household_id', household.id);
            },
        });
    };
    return (React.createElement(AddEditContactForm, { canEdit: canEdit, ageRanges: ageRanges, households: households, tenancyTypes: tenancyTypes, onAddHousehold: handleAddHousehold, isAddingHousehold: addHousehold.isPending, formVariant: variant }));
};
export default ContactFormWrapper;
